import { createReducer, on } from '@ngrx/store';
import { setAxisExtremes } from './axis-extremes.action';
export const axisExtremes = createReducer({}, on(setAxisExtremes, (state, action) => action.axisExtremes));
